import { createContext, Component } from 'react'
import { lightTheme } from './lightTheme'
import { darkTheme } from './darkTheme'

// Create Theme Context
export const ThemeContext = createContext()

// Theme Context Provider Component
export class ThemeContextProvider extends Component {
  constructor (props) {
    super(props)

    // Initialize theme from localStorage or default to light
    const savedTheme = localStorage.getItem('ems-theme')
    const isDark = savedTheme === 'dark'

    this.state = {
      isDark,
      theme: isDark ? darkTheme : lightTheme
    }
  }

  toggleTheme = () => {
    this.setState(
      prevState => {
        const newIsDark = !prevState.isDark
        const newTheme = newIsDark ? darkTheme : lightTheme

        // Persist theme preference in localStorage
        localStorage.setItem('ems-theme', newIsDark ? 'dark' : 'light')

        return {
          isDark: newIsDark,
          theme: newTheme
        }
      }
    )
  }

  setTheme = (themeName) => {
    const isDark = themeName === 'dark'
    const theme = isDark ? darkTheme : lightTheme

    localStorage.setItem('ems-theme', themeName)

    this.setState({
      isDark,
      theme
    })
  }

  render () {
    const { isDark, theme } = this.state

    const value = {
      isDark,
      theme,
      toggleTheme: this.toggleTheme,
      setTheme: this.setTheme,
      themeName: theme.name
    }

    return (
      <ThemeContext.Provider value={value}>
        {this.props.children}
      </ThemeContext.Provider>
    )
  }
}

// HOC for class components to access theme context
export const withTheme = (Component) => {
  return (props) => (
    <ThemeContext.Consumer>
      {(themeContext) => <Component {...props} themeContext={themeContext} />}
    </ThemeContext.Consumer>
  )
}
